/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_No_Clients_HintInputs */



/**
* | output |
* | --- |
* | "Click \"Register App\" to get started." |
*
* @param {Developer_No_Clients_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_no_clients_hint = /** @type {((inputs?: Developer_No_Clients_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_No_Clients_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur « Enregistrer une app » pour commencer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic en \"Registrar aplicación\" para comenzar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Clique em \"Registrar App\" para começar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clicca \"Registra App\" per iniziare.")
	return /** @type {LocalizedString} */ ("Click \"Register App\" to get started.")
});